/**
 * Serviços para funções do banco de dados Supabase
 * Permite executar stored procedures e functions com isolamento multi-tenant
 */

import { Database } from "@/types";
import { supabase } from "../../../../supabaseConfig";

type FunctionName = keyof Database["public"]["Functions"];

/**
 * Classe base para serviços de funções do banco
 */
export class BaseFunctionService {
  protected client = this.getClient();

  private getClient() {
    return supabase;
  }

  /**
   * Executa uma função RPC no Supabase
   */
  protected async rpc<T = any>(
    functionName: FunctionName,
    params?: any,
  ): Promise<T> {
    const { data, error } = await this.client.rpc(functionName as any, params);

    if (error) {
      throw new Error(
        `Erro ao executar função ${functionName}: ${error.message}`,
      );
    }

    return data;
  }
}
